import { Component, inject } from '@angular/core';
import { EditCaseDialogService } from '../edit-case-dialog.service';
import { DebtorFormComponent } from '../debtor-form/debtor-form.component';

@Component({
  selector: 'app-debtors-form',
  templateUrl: './debtors-form.component.html',
  styleUrls: ['./debtors-form.component.scss'],
  imports: [DebtorFormComponent],
})
export class DebtorsFormComponent {
  private editCaseDialogService = inject(EditCaseDialogService);

  get debtors() {
    return this.editCaseDialogService.form.controls.debtors;
  }

  get partyTypes() {
    return this.editCaseDialogService.partyTypes;
  }

  get representativeTypes() {
    return this.editCaseDialogService.representativeTypes;
  }

  get countries() {
    return this.editCaseDialogService.countries;
  }
}
